import { AccountInfo } from '@azure/msal-browser';

export enum IntegrationTypeEnum {
    GOOGLE = 1,
    MICROSOFT = 2,
    CUSTOM = 10,
}

export enum IntegrationServiceTypeEnum {
    EMAIL = 1,
    CALENDAR = 2,
    LOGIN = 3,
    ALL = 99,
}

export type IntegrationCredentialType = {
    credential_id: number;
    account_id: number;
    parent_account_id: number;

    integration_type: IntegrationTypeEnum | number;

    is_calendar_enabled: boolean;
    is_email_enabled: boolean;

    email?: string;
    access_token?: string;
    last_issued?: Date; // UTC Date
    expires_in?: Date; // UTC Date
    rt_last_issued?: Date; // Integration's Refresh token last issued UTC Date
    rt_expires_in?: Date; // Integration's Refresh token expiry UTC Date
    token_type?: string;
    refresh_token?: string;
    scope?: string[] | string;
    meta_account?: AccountInfo | string;

    metadata?: any;

    created_at: Date;
    updated_at?: Date;
};
